import {WinPresentationController} from "../WinPresentationController";
import {Layers, WalkOfShameLayers} from "../../view/WalkOfShameLayers";
import {TimelineLite} from "gsap";
import {WalkOfShame} from "../../WalkOfShame";
import {WalkOfShameGameMode} from "../../server/WalkOfShameGameMode";
import {WalkOfShameSound} from "../../sound/WalkOfShameSound";
import {MathHelper} from "../../../core/utils/MathHelper";

export class ReSpinStartController extends WinPresentationController {
    private readonly _item: PIXI.Sprite;
    private _prevSound: string = "";

    constructor() {
        super("ReSpinStartController", false);

        this._item = new PIXI.Sprite(WalkOfShame.assetLoader.getTextures("logoColors_FS/triggerRespin")[0]);
        this._item.visible = false;
        this._item.anchor.set(0.5);
        this._item.position.set(360);

        WalkOfShameLayers.getLayer(Layers.RESPIN_START)?.addChild(this._item);
    }

    protected async createWinAnimation(): Promise<void> {
        WalkOfShame.logo.onModeChange(WalkOfShame.model.parsedGameData.nextMode, false);

        const tl: TimelineLite = new TimelineLite();

        tl.add(() => {
            this._item.alpha = 0;
            this._item.visible = true;

            let sound: string = WalkOfShameSound.WILD_WALKING_START[MathHelper.randomNumberInRange(0, WalkOfShameSound.WILD_WALKING_START.length - 1)];

            while (this._prevSound === sound) {
                sound = WalkOfShameSound.WILD_WALKING_START[MathHelper.randomNumberInRange(0, WalkOfShameSound.WILD_WALKING_START.length - 1)];
            }
            WalkOfShameSound.soundPlayer.playTrack({
                name: sound
            });
            this._prevSound = sound;
        });
        tl.to(this._item, {
            duration: 0.3,
            alpha: 1
        });
        tl.to(this._item.scale, {
            duration: 0.3,
            x: 1.3,
            y: 1.3
        });
        tl.to(this._item.scale, {
            duration: 0.3,
            x: 1,
            y: 1
        }, 0.8);
        tl.to(this._item, {
            duration: 0.3,
            alpha: 0
        }, 1);
        tl.add(() => {
            this._item.visible = false;
            this._item.alpha = 1;
        });

        await tl;
    }

    protected hasWin(): boolean {
        return (WalkOfShame.model.parsedGameData.mode === WalkOfShameGameMode.NORMAL && WalkOfShame.model.parsedGameData.nextMode === WalkOfShameGameMode.RESPIN) ||
            (WalkOfShame.model.parsedGameData.mode === WalkOfShameGameMode.SUPER_FREESPIN && WalkOfShame.model.parsedGameData.nextMode === WalkOfShameGameMode.SUPER_FREESPIN_RESPIN);
    }
}